import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import {
  FORCE_COBRANCAS,
  SYNC_DISCIPLINAS,
  SYNC_UNIDADES_FORNECEDORES,
  FETCH_UNIDADES_FORNECEDOR_ZERADO

} from "@/store/actions/actions.type";
import {
  FETCH_COBRANCAS_START,
  FETCH_COBRANCAS_END,
  FETCH_DISCIPLINAS_RETURN_END,
  FETCH_DISCIPLINAS_RETURN_START,
  FETCH_FORNECEDORES_UNIDADES_END,
  FETCH_FORNECEDORES_UNIDADES_START,
  SET_FORNECEDORES_UNIDADES_RETURN,
  SET_COBRANCAS_RETURN,
  SET_SYNC_DISCIPLINAS_RETURN,
  SET_UNIDADES_FORNECEDORES_ZERADO
} from "@/store/mutations/mutations.type";

const state = {
  cobrancasReturn: "",
  syncFornecedoresUnidadesReturn: "",
  syncDisciplinasReturn: "",
  isFetchingCobrancas: false,
  isFetchingFornecedoresUnidades: false,
  isFetchingDisciplinasReturn: false,
  unidadesComFornecedorZerado: 0,
};

const getters = {
  cobrancasReturn(state) {
    return state.cobrancasReturn;
  },
  unidadesComFornecedorZerado(state) {
    return state.unidadesComFornecedorZerado;
  },
  syncFornecedoresUnidadesReturn(state) {
    return state.syncFornecedoresUnidadesReturn;
  },
  syncDisciplinasReturn(state) {
    return state.syncDisciplinasReturn;
  },
  isFetchingCobrancas(state) {
    return state.isFetchingCobrancas;
  },
  isFetchingFornecedoresUnidades(state) {
    return state.isFetchingFornecedoresUnidades;
  },
  isFetchingDisciplinasReturn(state) {
    return state.isFetchingDisciplinasReturn;
  }
};

const actions = {
  [FETCH_UNIDADES_FORNECEDOR_ZERADO](context, params) {
    return new Promise((resolve, reject) => {

      ApiAdmin.query("area-ti/unidadesFornecedorZerado", params)
        .then(response => {
      console.log(response.data.count);
          context.commit(SET_UNIDADES_FORNECEDORES_ZERADO, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
        });
    });
  },
  [SYNC_DISCIPLINAS](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DISCIPLINAS_RETURN_START);

      ApiAdmin.query("royalties/list", params)
        .then(response => {
          context.commit(SET_SYNC_DISCIPLINAS_RETURN, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_DISCIPLINAS_RETURN_END);
        });
    });
  },
  [SYNC_UNIDADES_FORNECEDORES](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_FORNECEDORES_UNIDADES_START);

      ApiAdmin.query("area-ti/syncUnidadesFornecedores", params)
        .then(response => {
          context.commit(SET_FORNECEDORES_UNIDADES_RETURN, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_FORNECEDORES_UNIDADES_END);
        });
    });
  },
  [FORCE_COBRANCAS](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_COBRANCAS_START);

      ApiAdmin.query("area-ti/cobrancasMensais", params)
        .then(response => {
          context.commit(SET_COBRANCAS_RETURN, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_COBRANCAS_END);
        });
    });
  }
};

const mutations = {
  [FETCH_DISCIPLINAS_RETURN_START](state) {
    state.isFetchingDisciplinasReturn = true;
  },
  [FETCH_DISCIPLINAS_RETURN_END](state) {
    state.isFetchingDisciplinasReturn = false;
  },
  [FETCH_COBRANCAS_START](state) {
    state.isFetchingCobrancas = true;
  },
  [FETCH_COBRANCAS_END](state) {
    state.isFetchingCobrancas = false;
  },
  [FETCH_FORNECEDORES_UNIDADES_START](state) {
    state.isFetchingFornecedoresUnidades = true;
  },
  [FETCH_FORNECEDORES_UNIDADES_END](state) {
    state.isFetchingFornecedoresUnidades = false;
  },
  [SET_UNIDADES_FORNECEDORES_ZERADO](state, unidadesComFornecedorZerado) {
    state.unidadesComFornecedorZerado = unidadesComFornecedorZerado.count || 0;
  },
  [SET_FORNECEDORES_UNIDADES_RETURN](state, syncFornecedoresUnidadesReturn) {
    state.syncFornecedoresUnidadesReturn = syncFornecedoresUnidadesReturn;
  },
  [SET_COBRANCAS_RETURN](state, cobrancasReturn) {
    state.cobrancasReturn = cobrancasReturn;
  },
  [SET_SYNC_DISCIPLINAS_RETURN](state, syncDisciplinasReturn) {
    state.syncDisciplinasReturn = syncDisciplinasReturn;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
